var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "qr-code-tester-wrapper" },
    [
      _c(_setup.CInput, {
        staticClass: "flex-fill",
        attrs: {
          label: "Type/Paste a URL or text to encode",
          disabled: _setup.disabled,
        },
        model: {
          value: _setup.model.data,
          callback: function ($$v) {
            _vm.$set(_setup.model, "data", $$v)
          },
          expression: "model.data",
        },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        staticClass: "ml-auto",
        attrs: {
          variant: "light",
          text: "Generate QR",
          disabled: _setup.disabled || !_setup.model.data.trim(),
        },
        on: { click: _setup.generateQr },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }